import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './ChatbotTest.css';
import { FaPaperPlane, FaTrash } from 'react-icons/fa';
import Button from './UI/Button';

const ChatbotTest = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      fetchUserData(token);
    }
  }, []);

  const fetchUserData = async (token) => {
    try {
      const response = await axios.get('/api/users/user', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
      fetchMessages(response.data._id);
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      setUser(null);
    }
  };

  const fetchMessages = async (userId) => {
    try {
      const response = await axios.get(`/api/webhook/chatbot/test/${userId}`);
      setMessages(response.data.messages);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !user) return;

    setLoading(true);
    try {
      await axios.post('/api/webhook/chatbot/test', {
        user_id: user._id,
        message: newMessage
      });
      setNewMessage('');
      await fetchMessages(user._id);
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteConversation = async () => {
    if (!user) return;
    
    try {
      await axios.delete(`/api/webhook/chatbot/test/${user._id}`);
      setMessages([]); // Clear messages immediately
    } catch (error) {
      console.error('Error deleting conversation:', error);
    }
  };

  // Expose the delete function to parent components
  useImperativeHandle(ref, () => ({
    deleteConversation: handleDeleteConversation
  }));

  return (
    <div className="chatbot-test-container">
      <div className="messages-container">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`message ${message.is_ai ? 'ai' : 'user'}`}
          >
            <div className="message-content">{message.content}</div>
            <div className="message-timestamp">
              {new Date(message.created_at).toLocaleTimeString()}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={handleSubmit} className="message-form">
        <div className="input-container-chatbottest">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder={t('chatbotTest.typePlaceholder')}
            disabled={loading}
          />
          <Button 
            variant="tertiary"
            type="submit" 
            disabled={loading} 
            className="send-button"
          >
            <FaPaperPlane className={loading ? 'loading' : ''} />
          </Button>
        </div>
      </form>
    </div>
  );
});

export default ChatbotTest;